// extracted by mini-css-extract-plugin
module.exports = {"report_selectors":"index-report_selectors__2qst7"};